

















































































import { Component, Vue } from 'vue-property-decorator';
import SocialMediaIcons from '@/shared/components/SocialMediaIcons.vue';

@Component({
    components: {
        SocialMediaIcons
    },
})
export default class Contact extends Vue {
    private list = new Array(25).fill({q: "", a: ""}).map((x, index) => ({
        "q": "faqs.q-"+ parseInt(index.toString() + 1),
        "a": "faqs.a-"+ parseInt(index.toString() + 1)
    }));

    private openQuestions: any = [];

    private toggleQuestion(index: number) {
        if (this.openQuestions.includes(index)) {
            this.openQuestions = this.openQuestions.filter((x: number) => x !== index)
        } else {
            this.openQuestions = [index]
        }
    }

    private isOpen(index: number) {
        return this.openQuestions.includes(index)
    }

    private mounted() {
        console.log(this.list)
    }
}
